// extracted by mini-css-extract-plugin
export default {"emptyStep":"empty-step_emptyStep__Y6Fhc","inner":"empty-step_inner__CtcWX"};